import React, { useState, useMemo } from 'react';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import DatePicker from '../../Components/Datepicker_Basic';
import BasicButton from '../../Components/Button_Basic';
import Input from '../../Components/Input_Basic';
import FormGroup from '../../Components/Form_Group';
import CardH3 from '../../Components/Card_H3';
import GridModal from '../../Components/Modal_Grid';
import Commons from '../../Services/Common/Common';
import Radio from '../../Components/Radio_Basic';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';

function MM10040(props) {
    React.useEffect(() => {
        document.title = '생산실적현황';

        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '생산관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>생산실적현황</strong>" +
            '</h1>';
    }, []);

    const [selectedRowData, setSelectedRowData] = React.useState(null);
    const [modalToggle, setModalToggle] = React.useState(false);
    const [selectedModalData, setSelectedModalData] = React.useState(null);
    const [checkInputs, setCheckInputs] = React.useState({
        value: '',
        value1: '',
    });

    const rowGroupPanelShow = 'always';
    const groupDefaultExpanded = 1;
    const gridRef = React.useRef();
    const gridRef1 = React.useRef();
    const autoGroupColumnDef = useMemo(() => {
        //그룹설정
        return {
            headerName: '거래처명',
            minWidth: 250,
        };
    }, []);
    const [selectedRadio, setSelectedRadio] = React.useState('0');

    const onCellClicked = (e) => {
        const selected = e.data;

        // props.SearchBomLogic(selected.woNo, selected.itemCd);
    };
    React.useEffect(() => {
        setSelectedRadio(props.selectedRadio);
    }, [props.selectedRadio]);

    return (
        <div style={{ width: '100%' }}>
            <div style={{ height: '50%' }}>
                <Section />
                <Card
                    wrapStyle={{
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        지시일자
                        <DatePicker
                            className={'datepicker-custom-input'}
                            style={{ width: '120px', marginRight: '5px', marginLeft: '5px' }}
                            selected={props.startDate}
                            onChange={(e) => {
                                props.setStartDate(e);
                            }}
                        />
                        ~
                        <DatePicker
                            className={'datepicker-custom-input'}
                            style={{ width: '130px', marginLeft: '5px' }}
                            selected={props.endDate}
                            onChange={(e) => {
                                props.setEndDate(e);
                            }}
                        />
                        <Radio
                            style={{
                                display: 'flex',
                            }}
                            labelStyle={{ width: '5px' }}
                            items={[
                                //전체
                                {
                                    value: '0',
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Radio_All' && f.lanType === 'RADIO'
                                              )[0].lanName
                                            : '',
                                },
                                //거래처
                                {
                                    value: '1',
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Radio_CustName' && f.lanType === 'RADIO'
                                              )[0].lanName
                                            : '',
                                },
                            ]}
                            value={props.selectedRadio}
                            onChange={(e) => {
                                props.setSelectedRadio(e.target.value);
                            }}
                        />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        {/* 그리드 버튼 */}
                        <AuthGroupButton
                            pageName="MM10040"
                            target="G01"
                            refreshNone="none"
                            selectFunc={() => {
                                props.SearchLogic();
                            }}
                            addFunc={() =>
                                // gridRef.current.api.setRowData([{}, ...props.rowData])
                                props.setModalToggle(true)
                            }
                            saveFunc={() => props.SaveConfirm()}
                            deleteFunc={() => props.DeleteConfirm()}
                            // onCellClicked={onCellClicked}
                        />
                    </div>
                </Card>
                <Section />
                <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '770px' }}>
                    {/* 그리드  */}
                    <AgGridReact
                        ref={gridRef}
                        animateRows={true}
                        columnDefs={props.columnDefs}
                        autoGroupColumnDef={autoGroupColumnDef}
                        // groupIncludeTotalFooter={true}
                        defaultColDef={{
                            flex: 1,
                            minWidth: 100,
                            editable: false,
                            resizable: true,
                            sortable: true,
                            filter: true,
                            floatingFilter: true,
                        }}
                        rowData={props.rowData}
                        rowSelection="single"
                        onSelectionChanged={() => GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData)}
                        groupDisplayType={'singleColumn'}
                        onCellClicked={onCellClicked}
                        onCellValueChanged={(e) =>
                            GridFunctions.onCellValueChanged(e, gridRef, props.setChangedRowData)
                        }
                        enableCellChangeFlash={true}
                    />
                </div>
            </div>
        </div>
    );
}

export default MM10040;
